<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link>
  </nav> -->
   <keep-alive>

  <router-view/>
   </keep-alive>
  <Canvas/> 
</template>
 
<style>
    .fw-bold7{
        font-weight: 700 !important;
    }
    .form-control{
        box-shadow: none !important;
    border: 1px solid gray;
    color: black;
    font-weight: 800;
    }
    .btn {
    font-size: 16px;
}
.fullheight{
    height: 100% !important;
}
.mr-2{
    margin-left: 15px;
}

.mr-1{
    margin-left: 10px;
}
.rounded-ic{
       background: #d8e8ff;
    padding: 5px;
    border-radius: 50px !important; 
}
 .bi{
    height: 35px;
    width: 35px;

}
.header_new{
    border-radius: 0px 0px 20px 20px;
    background: linear-gradient(135deg, #0056c2 0%, #003a75 100%);
}
.newbtn{
    background: linear-gradient(135deg, #0056c2 0%, #003a75 100%);
}
</style>
<script>
import Canvas from '@/components/canvas.vue'  ;

export default {
  
  components: {
    Canvas 
  },
  mounted(){ 
      
  },
   data() {
          return { 
            loading:false,
            error:null,
        };
   },
  methods:{
    
    // loadBasics(){
    //  var $main_nav = $('#main-nav');
    // var $toggle = $('.toggle');
    // var defaultOptions = {
    //     disableAt: false,
    //     customToggle: $toggle,
    //     levelSpacing: 40,
    //     navTitle: 'App',
    //     levelTitles: true,
    //     levelTitleAsBack: true,
    //     pushContent: '#container',
    //     insertClose: 2
    // };
    // var Nav = $main_nav.hcOffcanvasNav(defaultOptions);
    // }
  }
}
</script>
<style>
.bg-primary,.footer{
    background-color: #006c6f !important;
  /*background: linear-gradient(328deg, #ff0000, #000199);*/
}
.footer a{
  color: white !important;
    font-weight: 600;
}
</style>
